import Vue from 'vue'
import Vuex from 'vuex'
import ElementUI from 'element-ui'
import echarts from 'echarts'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import App from './App'
import router from './router'
import store from './store'
import VideoPlayer from 'vue-video-player'
import * as custom from '@/utils/time'
import Permission from './directive/permission'
import VueCropper from 'vue-cropper'
import { getToken } from '@/utils/auth'
import lottie from 'vue-lottie';//动画
import UUID from 'vue-uuid'
import JSEncrypt from 'jsencrypt';
import {loadinguploadtitle} from './assets/js/wx-upload'// 上传应用时遮罩层
import '@/styles/iconfont.css'
import 'default-passive-events'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/dist/css/swiper.css'
import "babel-polyfill"
import '@/styles/common.css'
import '@/styles/whole.css'
import 'videojs-flash'
import './assets/js/parseInt'


// import './mock/mock-server'
Vue.component('lottie', lottie)

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
const hls = require('videojs-contrib-hls')
Object.keys(custom).forEach(key => { Vue.filter(key, custom[key]) })
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.SHADE = loadinguploadtitle
Vue.use(VueCropper)
Vue.use(UUID)
Vue.use(hls)
Vue.use(VideoPlayer)
Vue.use(Permission)//权限按钮
Vue.use(Vuex);
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)




//rsa 解密全局方法
Vue.prototype.$sendEncryCode = function (params) {
    let jse = new JSEncrypt();
    let privKey = `-----BEGIN PRIVATE KEY-----
    MIICdQIBADANBgkqhkiG9w0BAQEFAASCAl8wggJbAgEAAoGBAKYGNM2g1siOtlWg
    S3k4E0zrNn/INnvCC/ncDp6RO4Cyp8neNeYsLs+qqsnGCqoN/aXvYKdELxnEgCSJ
    QGYgr8UgOuWoIE+XWHRibyo8uZS6/mXfGaGVvr5r+/bbjjg9b9TpSvSXUG9sKiuu
    xZXeV4UV8tnmhPiar2NfORAu/wXrAgMBAAECf0qUfyPgHJv7f+z3FPBfQExNXS4J
    wm/Vu4uCTw7sLs6hcr48E/pR3rVq9U2uqRu7LTZdUg3Rk1b/7pB7F3LJPCuX5n/t
    nqcEWfWoyAc6wnVLffxkvx7toD7nMl7+2/LsUgSiY/QFdG43dKs+5rXuEOOwcZV/
    tLdivN9SEN44mEECQQDXls/rpMPYnd0IHHqh6YZEA3dH1CZAWeW/4XF/BINW/02m
    jtoNr+sTcZN9ekaLFTQnF/jJRi35dNwGhroG+k/hAkEAxST9oYDugGPTbu81JU1p
    nO8tLQPHvpVu3lGQEFahWZi6j70FlhNEhX74lDLrhvTOI4ohzHX28pU5TbQkiyl/
    SwJBALxQseHmFGR80HurVLtlnrB+TozhlWAUpolLRbZrnMY7T/qzQWk/Rxm+1dR/
    IGuQ4/NaDyjRMot6Nk9FE+3QbEECQQCXib+MDVdHSXSUqTro2YB9KTxIhcdcL/Fw
    4rEiXfTYshV1t447tcPN+bOJ9zokGrj5iIxCZcrU3O+XUwlkDxnRAkArwYiJZFlS
    Lu9zj+e03+kGWu6c/x8RRoLqfZcWFffBZlkxOHa06aN6jYCdJtRON43JUbynMvDY
    l5glkcwnZlbi
    -----END PRIVATE KEY-----`

    jse.setPrivateKey(privKey);
    let data = jse.decrypt(params); //解密

    return data;
}

//rsa 加密全局方法
Vue.prototype.$getRsaCode = function (str) { // 注册方法


    let pubKey = `-----BEGIN PUBLIC KEY-----
    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCmBjTNoNbIjrZVoEt5OBNM6zZ/
    yDZ7wgv53A6ekTuAsqfJ3jXmLC7PqqrJxgqqDf2l72CnRC8ZxIAkiUBmIK/FIDrl
    qCBPl1h0Ym8qPLmUuv5l3xmhlb6+a/v22444PW/U6Ur0l1BvbCorrsWV3leFFfLZ
    5oT4mq9jXzkQLv8F6wIDAQAB
    -----END PUBLIC KEY-----`;// ES6 模板字符串 引用 rsa 公钥
    let encryptStr = new JSEncrypt();
    encryptStr.setPublicKey(pubKey); // 设置 加密公钥
    let data = encryptStr.encrypt(str.toString());  // 进行加密

    return data;


}

new Vue({
    store,
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js